export const CUSTOMER_SERVICES = [
  {
    id: 'NL',
    phone: '088 488 29 76',
    email: 'pluimvee@agrifirm.com',
  },
];
